import React, { useState, useRef, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

import { FaFilter } from "react-icons/fa";
import { BiCaretDown } from "react-icons/bi";
import { StoreContext } from "../../store/Store";
import { APIContext } from "./../../store/APIStore";
import Popper from "@mui/material/Popper";
import { registrationStatus } from "../../dataProvider/interfaces/IAttendee";
import FdTextField from "../UIComponents/TextField/FdTextfield";
import FdTypography from "../UIComponents/Typography/FdTypography";
import FdButton from "../UIComponents/Button/FdButton";
import { attendeeFilterStyle as classes } from "./styles";
import { useForm, Controller } from "react-hook-form";
import FdAutoComplete from "../UIComponents/AutoComplete/FdAutoComplete";


export const filterOptions = [
  {
    label: "Category",
    key: "category",
  },
  {
    label: "Name",
    key: "name",
  },
  {
    label: "Email",
    key: "email",
  },
  {
    label: "Registration Status",
    key: "registrationStatus",
  },
  // {
  //   label: "Company",
  //   key: "company",
  // },
  // {
  //   label: "Country",
  //   key: "country",
  // },
  // {
  //   label: "Title",
  //   key: "title",
  // },
  // {
  //   label: "Subcategory",
  //   key: "subcategory",
  // },
];

export interface IProps {
  eventId: number;
  onFilterSelect: Function;
}

const AttendeeFilters = ({ eventId, onFilterSelect }: IProps) => {
  const [filterAnchorEl, setFilterAnchorEl] =
    useState<null | HTMLElement>(null);
  const [formAnchorEl, setFormAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [attendeeCategories, setAttendeeCategories] = useState<any[]>([]);
  const [, dispatch] = useContext(StoreContext);
  const filterValueRef = useRef<any>();
  const api = useContext(APIContext);

  useEffect(() => {
    fetchAttendeeCategories();
    return () => {
      setAttendeeCategories([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // we need to clear the filled filter value when hovering among filters
    if (filterValueRef.current) {
      filterValueRef.current.value = "";
    }
  }, [selectedIndex]);

  const fetchAttendeeCategories = async () => {
    try {
      const data = (await api.eventService.getAttendeeCategories(
        eventId
      )) as any;
      setAttendeeCategories(data);
      dispatch({ type: "SET_ATTENDEE_CATEGORIES_LIST", payload: { list: data, isApiCallDone: true, loading: true } });
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleOptionView = (
    event: React.MouseEvent<HTMLButtonElement | HTMLLIElement>,
    index: number
  ) => {
    // setFilterAnchorEl(null);
    setFormAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setFilterAnchorEl(null);
    setFormAnchorEl(null);
    setSelectedIndex(-1);
  };
  const {
    handleSubmit,
    control,
  } = useForm();

  const getFilterValueInput = () => {
    if (selectedIndex !== -1) {
      switch (filterOptions[selectedIndex].key) {
        // category filter
        case filterOptions[0].key:
          return (
            <form onSubmit={handleSubmit(applyFilters)} noValidate autoComplete="off">
              <Controller
                control={control}
                name="filterCategory"
                render={({ field: { value } }) => (
                  <FdAutoComplete
                    disablePortal
                    id="filterCategoryInput"
                    options={attendeeCategories}
                    getOptionLabel={(option: any) => (option.name ? option.name : "")}
                    sx={classes.categotyAutoComplete}
                    renderInput={(params) => (
                      <FdTextField {...params} inputRef={filterValueRef} />
                    )}
                  />
                )}
              />
            </form>

          );
        case filterOptions[3].key:
          return (
            <form onSubmit={handleSubmit(applyFilters)} noValidate autoComplete="off">
              <Controller
                control={control}
                name="filterRegStatus"
                render={() => (
                  <FdAutoComplete
                    disablePortal
                    id="filterRegStatusInput"
                    options={Object.values(registrationStatus)
                      .filter((value) => typeof value === "string")
                      .map((status: string, index: number) => ({
                        name: status,
                        id: index,
                      }))}
                    getOptionLabel={(option: any) => (option.name ? option.name : "")}
                    sx={classes.filterAutoComplete}
                    renderInput={(params) => (
                      <FdTextField {...params} inputRef={filterValueRef} />
                    )}
                  />
                )}
              />
            </form>

          );
        // TODO subcategory filter
        // case filterOptions[4].key:
        //   return;
        // rest of the filters
        default:
          return (
            <FdTextField
              inputRef={filterValueRef}
              required={false}
              name="filterValue"
              id="filterValueInput"
              sx={classes.searchTextField}
            />
          );
      }
    }

    return;
  };

  const applyFilters = () => {
    const filterValue = filterValueRef.current.value;
    if (filterValue.toString().length > 0) {
      onFilterSelect({
        key: filterOptions[selectedIndex].key,
        value: filterValue,
        operation: "~",
      });
      handleClose();
    }
  };

  const filterValueInput = getFilterValueInput();
  return (
    <Box width="20%" paddingRight="20px" id="filterContainer">
      <FdButton
        variant="text"
        sx={classes.filterButton}
        aria-controls="filter-selector"
        aria-haspopup="true"
        onClick={handleFilterClick}
        startIcon={<FaFilter />}
        endIcon={<BiCaretDown />}
      >
        <Box component="span" color="#000" flexGrow="1" textAlign="left">
          Select filters
        </Box>
      </FdButton>

      {/* Filter Categories */}
      <Menu
        disableEnforceFocus
        sx={classes.filterMenu}
        id="filterMenu"
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleClose}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        //TODO: below code commented for mui v5
        // getContentAnchorEl={null}
        container={document.getElementById("filterContainer")}
      >
        {filterOptions.map((option, index) => (
          <MenuItem
            key={option.key}
            selected={index === selectedIndex}
            onMouseOver={(event) => handleOptionView(event, index)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Filter Form */}
      <Popper
        sx={classes.filterForm}
        id="filterForm"
        open={Boolean(formAnchorEl)}
        anchorEl={formAnchorEl}
        placement="right-start"
      >
        <Box sx={classes.filterFormWrapper}>
          <Box sx={classes.filterFormControls}>
            <FdTypography label={`${filterOptions[selectedIndex]?.label} Is Like:`} />
            {filterValueInput}
          </Box>
          <Divider sx={{ margin: 0 }} />
          <Box sx={classes.filterFormActions}>
            <FdButton
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                applyFilters();
              }}
              sx={{ marginLeft: "10px", fontSize: '0.8125rem' }}
              ButtonName="Apply"
            />
          </Box>
        </Box>
      </Popper>
    </Box>
  );
};

export default AttendeeFilters;
